import QuotationList from '_modules/quotation/views/QuotationList.vue';
import QuotationEdit from '_modules/quotation/views/QuotationEdit.vue';
import QuotationCreate from '_modules/quotation/views/QuotationCreate.vue';
// eslint-disable-next-line
const Quotation = r => require(['_modules/quotation/Root.vue'], r);

export default {
  path: 'orcamentos/',
  component: Quotation,
  name: 'admin-quotation',
  redirect: 'quotation/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-quotation-list',
      component: QuotationList,
    },
    {
      path: 'new',
      name: 'admin-quotation-new',
      component: QuotationCreate,
    },
    {
      path: ':quotationId',
      name: 'admin-quotation-edit',
      component: QuotationEdit,
    },
  ],
};
